module.exports = __webpack_public_path__ + "static/img/atmosphere-mask-notice-3.80a6f0f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/atmosphere-mask/images/atmosphere-mask-notice-3.jpg
// module id = Dpzu
// module chunks = 0